import React, { useState } from 'react';
import PropTypes from 'prop-types'
import './InteractiveItem.scss';
import Modal from '../common/Modal/Modal';
import Scroll from '../../../partials/Scroll/Scroll';

var widgetHeight = 400;
var widgetWidth = 400;
var baseDim = 400;
var factor = 1;

export const InteractiveItem = ({
  show,
  sensor,
  onComplete
}) => {

  const { dots } = sensor || {};
  const [dotDialogShow, setDotDialogShow] = useState(false);
  const [selectedDot, setSelectedDot] = useState(dots[0]);
  const [image, setImage] = useState(null);

  const onSelect = (dotIndex) => {
    setSelectedDot(dots[dotIndex]);
    setDotDialogShow(true);
  }

  var imagePath = sensor.img;

  React.useEffect(() => {
    const loadImage = (imageUrl) => {
      const img = new Image();
      img.src = window.location.protocol + '//' + window.location.host + window.location.pathname + imageUrl;

      img.onload = (i) => {
        setImage(i)
      };
      img.onerror = (err) => {
        console.log("img error");
        console.error(err);
      };
      return image;
    };
    loadImage(imagePath);
  }, [imagePath]);

  var imageSection = null;
  console.log(image);

  if (image) {
    widgetHeight = image.path[0].naturalHeight;
    widgetWidth = image.path[0].naturalWidth;
    if (widgetHeight>=widgetWidth){
      factor = widgetHeight/baseDim
      widgetHeight = 400
      widgetWidth = Math.floor(widgetWidth/factor)
    } else {
      factor = widgetWidth/baseDim
      widgetWidth = 400
      widgetHeight = Math.floor(widgetHeight/factor)
    }
  }
 

  if (dots) {
    imageSection = (
      <div
        id="interactive-image"
        className="interactive-image"
        style={{
          backgroundImage: `url(${imagePath})`,
          height: `${widgetHeight}px`,
          width: `${widgetWidth}px`
        }}
      >
        {
          dots.map((dot, dotIndex) => (
            <div
              key={`hotspot-${dotIndex}`}
              className="hotspot"
              onClick={() => { onSelect(dotIndex) }}
              style={{
                top: `${dot.y > widgetHeight ? widgetHeight - 15 : dot.y}px`,
                left: `${dot.x > widgetWidth ? widgetWidth - 15 : dot.x}px`
              }}
            ></div>
          ))
        }
      </div>
    )
  }
  return (
    <Modal
      show={show}
      showContinue={true}
      size=""
      onContinueClick={() => { if (onComplete) onComplete() }}
    >
      <>
        <div style={{ display: 'flex', gap: '20px' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >

          {imageSection}

        </div>
        {/* This is for dot information */}
        <div className="dot-information">
          <Scroll>
            <div
              dangerouslySetInnerHTML={{ __html: selectedDot?.content }}
              className='dot-information-text'></div>
          </Scroll>
        </div>

      </div>
    </>
    </Modal >
  );

}

InteractiveItem.propTypes = {
  sensor: PropTypes.object.isRequired
}
